module.exports = "https://static.zego.com/_next/static/images/social-ireland-taxi-ae2f80244465b04b2d771e06af089904.jpg";